import { type IEngineSemanticTag } from '../form-builder/semanticTags/IEngineSemanticTag.ts';
import { isUniqueSemanticTag } from '../form-builder/semanticTags/isUniqueSemanticTag.ts';

/**
 * Costruisce la mappa `semanticFieldName -> rhfPath` usata per popolare
 * `context.semanticFields`.
 *
 * Input tecnico:
 * - `selectedPathBySemanticTagId`: path scelto dalla scansione widget.
 * - chiave `tagId`: UUID salvato in `directives.metadata.semanticTag`.
 *
 * Output runtime:
 * - chiave `semanticFieldName`: nome del catalogo letto dalle expression
 *   come `$semanticFields.<nomeTag>`.
 *
 * Il catalogo runtime fa da ponte stabile `tagId -> semanticFieldName`.
 */
export function buildPathBySemanticFieldName(
  selectedPathBySemanticTagId: Map<string, string>,
  semanticTags: IEngineSemanticTag[] | null | undefined,
): Map<string, string> {
  const pathBySemanticFieldName = new Map<string, string>();
  if (selectedPathBySemanticTagId.size === 0 || !semanticTags) {
    return pathBySemanticFieldName;
  }

  for (const semanticTag of semanticTags) {
    if (!semanticTag?.id || !semanticTag.nome) continue;
    if (!isUniqueSemanticTag(semanticTag)) continue;

    const rhfPath = selectedPathBySemanticTagId.get(semanticTag.id);
    if (!rhfPath) continue;

    pathBySemanticFieldName.set(semanticTag.nome, rhfPath);
  }

  return pathBySemanticFieldName;
}
